import { useEffect, useState } from 'react';
import { winnreAuth } from '../../../../../utils/axios';
import { LoadingSpinner } from '../../../../../Components/Molecules/LoadingUI';
import AiOutlineExclamationCircle from '@meronex/icons/ai/AiOutlineExclamationCircle';
import { giftSvg } from '../../../../../Routes/DealsAndDiscounts/Components/Header/svg';
import { isRewardsVisible } from '../../../../../utils/routing';

const terms = [
    {
        id: 0,
        title: (
            <label for={0} className={` ml-2 text-sm flex-1`}>
                I confirm that I have not represented or made any statements
                that are contrary to the official RERA (Real Estate Regulatory
                Authority) details of the project.
            </label>
        )
    },
    {
        id: 1,
        title: (
            <label for={1} className={` ml-2 text-sm flex-1`}>
                I acknowledge that 10% TDS will be deducted at the time of
                payout, and this amount will be reflected in my Form 26AS for
                tax purposes.
            </label>
        )
    },
    {
        id: 2,
        title: (
            <label for={2} className={` ml-2 text-sm flex-1`}>
                {' '}
                I agree to the{' '}
                <a
                    className="text-[#006EB7] underline"
                    href={`${window.reloy_env.PUBLIC_URL}/terms-and-conditions`}
                >
                    Terms & Conditions
                </a>{' '}
                and{' '}
                <a
                    className="text-[#006EB7] underline"
                    href="https://reloy.co/privacy-policy/"
                >
                    Privacy Policy
                </a>{' '}
                laid out by Loyalie IT Solutions Pvt Ltd.
            </label>
        )
    },
    {
        id: 3,
        title: (
            <label for={3} className={` ml-2 text-sm flex-1`}>
                I confirm that I am not liable to pay GST in the account where I
                am receiving the funds.
            </label>
        )
    },
    {
        id: 4,
        title: (
            <label for={4} className={` ml-2 text-sm flex-1`}>
                I understand that payouts made to me may fall under Section 194J
                of the Income Tax Act, which applies to fees for professional or
                technical services. As a result, I may be subject to tax
                deductions under this section, where applicable.
            </label>
        )
    },
    {
        id: 5,
        title: (
            <label for={5} className={` ml-2 text-sm flex-1`}>
                I am solely responsible for reporting this income in my ITR
                (Income Tax Return) filings. I agree to comply with all
                applicable tax laws, including the accurate disclosure of income
                received from these payouts.
            </label>
        )
    }
];
const FirstStep = ({
    setStep,
    loading,
    checkKycVerificationStatus,
    error,
    setOpenUploadBox,
    initiateWorkflow,
    closeKYCModal
}) => {
    const [checkedState, setCheckedState] = useState([
        false,
        false,
        false,
        false,
        false,
        false
    ]);
    const [showNoGSTDisclaimer, setNoGSTDisclaimer] = useState(false);
    const allChecked = checkedState.every((item, i) =>
        i === 3 ? true : item === true
    );
    const noGST = !checkedState[3];

    useEffect(() => {
        return setCheckedState(
            checkedState.map((item) => {
                return false;
            })
        );
    }, []);

    const acceptTerms = () => {
        setCheckedState(
            checkedState.map((item) => {
                return true;
            })
        );
    };
    const handleOnChange = (position) => {
        const updatedCheckedState = checkedState.map((item, index) =>
            index === position ? !item : item
        );
        setCheckedState(updatedCheckedState);

        if (updatedCheckedState[position]) {
            window?.webengage?.track('TnCSelected');
        }
    };

    const onContinue = () => {
        window?.webengage?.track('TnCAccepted');

        if (showNoGSTDisclaimer) {
            setOpenUploadBox(false);
        } else if (noGST) {
            setNoGSTDisclaimer(true);
        } else {
            // checkKycVerificationStatus();

            /*Previous flow was to redirec t to digilocker after tnc*/

            // initiateWorkflow('DIGILOCKER')
            setStep(4);
        }
    };

    return (
        <div className="px-3 md:px-8 py-4">
            {loading ? (
                <LoadingSpinner />
            ) : error ? (
                <div className=" flex flex-col justify-center items-center text-center">
                    <div className=" rounded-full bg-red-500 p-2 md:p-4 ">
                        <AiOutlineExclamationCircle className=" text-white h-7 w-7 md:h-8 md:w-8" />
                    </div>
                    <p className="leading-5 mt-3">{error}</p>
                </div>
            ) : (
                <>
                    {showNoGSTDisclaimer ? (
                        <div>
                            Email the required documents to accounts@reloy.co
                            and we will process the payout accordingly.{' '}
                        </div>
                    ) : (
                        <div className="">
                            {' '}
                            <div
                                className={`flex justify-between pb-0 md:pb-2 `}
                            >
                                <h1 className=" font-Poppins font-bold text-lg ">
                                    Terms & Conditions
                                </h1>
                                <button
                                    onClick={acceptTerms}
                                    className="text-lg text-[#006EB7] underline"
                                >
                                    Select all
                                </button>
                            </div>
                            {terms.map((term) => (
                                <div className="flex my-3">
                                    <input
                                        type="checkbox"
                                        onChange={() => handleOnChange(term.id)}
                                        id={term.id}
                                        value={term.title}
                                        checked={checkedState[term.id]}
                                        className="checkbox-sm bg-white rounded-md border-gray-100 checked:bg-blue-600"
                                        autoComplete="off"
                                    />

                                    {term.title}
                                </div>
                            ))}
                        </div>
                    )}

                    {!showNoGSTDisclaimer && (
                        <div className="flex pt-8">
                            <button
                                onClick={onContinue}
                                disabled={!allChecked || loading}
                                className="disabled:bg-[#BFBFBF] disabled:cursor-not-allowed bg-primary w-full text-white rounded font-bold px-6 h-8 md:h-10 "
                            >
                                Accept
                            </button>
                        </div>
                    )}
                    {/* <div className="flex pt-8">
                        <button
                            onClick={onContinue}
                            disabled={!allChecked || loading}
                            className="disabled:bg-[#BFBFBF] disabled:cursor-not-allowed bg-primary w-full text-white rounded font-bold px-6 h-8 md:h-10 "
                        >
                            Accept
                        </button>
                    </div> */}
                    {isRewardsVisible && (
                        <div
                            onClick={closeKYCModal}
                            className={`flex p-4 border-2 rounded-xl  cursor-pointer ${
                                showNoGSTDisclaimer ? 'mt-11' : 'mt-7'
                            }`}
                        >
                            {giftSvg}
                            <div className="ml-2">
                                <h1 className="font-semibold">
                                    Want to claim the whole amount?
                                </h1>
                                <p className="text-sm">
                                    Redeem your reward at our exclusive store
                                </p>
                            </div>
                        </div>
                    )}
                </>
            )}
        </div>
    );
};
export default FirstStep;
